import { Children } from "react";
import { StyledStepper } from "./Stepper.styled";
import StepperContext from "./StepperContext";

interface StepperProps {
  children?: React.ReactNode;
  onClick: (name: string, index: number) => void;
  size?: "small" | "medium" | "big";
  /**
   * Optional: Override the default background color of the stepper container.
   * @type string (e.g., "#FFFFFF", "red", "rgba(0,0,0,0.5)")
   */
  backgroundColor?: string;
  /**
   * Optional: Override the default border radius of the stepper container.
   * @type string (e.g., "8px", "0")
   */
  borderRadius?: string;
}

export default function Stepper({
  children,
  size = "small",
  onClick,
  backgroundColor,
  borderRadius,
  ...rest
}: StepperProps) {
  return (
    <StepperContext.Provider value={{
      stepLength: Children.count(children),
      onClick,
    }}>
      <StyledStepper
        className={size}
        $customBackgroundColor={backgroundColor}
        $customBorderRadius={borderRadius}
        {...rest}
      >
        {children}
      </StyledStepper>
    </StepperContext.Provider>
  );
}
